var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2041 10.541C7.74537 10.541 7.36084 10.9255 7.36084 11.3843C7.36084 11.843 7.74537 12.2275 8.2041 12.2275C8.64598 12.2275 9.04737 11.843 9.02713 11.4045C9.04737 10.9222 8.66621 10.541 8.2041 10.541Z",
    fill: "#FF6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0094 13.5293C16.539 12.6152 16.5423 11.5257 16.0162 10.615L10.7339 1.46728C10.2111 0.546436 9.26666 0 8.20752 0C7.14837 0 6.20392 0.549809 5.68109 1.46391L0.392134 10.6218C-0.134063 11.5426 -0.13069 12.6389 0.402254 13.553C0.928451 14.4569 1.86953 15 2.92193 15H13.4729C14.5286 15 15.4765 14.4502 16.0094 13.5293ZM14.8626 12.8682C14.5691 13.3742 14.0497 13.6744 13.4695 13.6744H2.91856C2.34514 13.6744 1.82906 13.3809 1.54235 12.8851C1.25226 12.3825 1.24889 11.7821 1.53897 11.2761L6.82793 2.12165C7.11464 1.61907 7.62735 1.32224 8.20752 1.32224C8.78431 1.32224 9.30039 1.62244 9.5871 2.12503L14.8727 11.2795C15.156 11.772 15.1526 12.3656 14.8626 12.8682Z",
    fill: "#FF6161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99524 4.62146C7.59384 4.73615 7.34424 5.10044 7.34424 5.54231C7.36448 5.80878 7.38134 6.07862 7.40158 6.3451C7.45892 7.36039 7.51626 8.35544 7.57361 9.37073C7.59384 9.71478 7.86032 9.96439 8.20437 9.96439C8.54842 9.96439 8.81827 9.69792 8.83513 9.35049C8.83513 9.14136 8.83513 8.9491 8.85537 8.7366C8.89247 8.0856 8.93295 7.43459 8.97005 6.78359C8.99029 6.36196 9.0274 5.94033 9.04763 5.5187C9.04763 5.36691 9.02739 5.23199 8.97005 5.09706C8.79803 4.71928 8.39663 4.52702 7.99524 4.62146Z",
    fill: "#FF6161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c8deb7ffc8d7c8517b060c686ddfeef3.svg";
export { ForwardRef as ReactComponent };